import * as React from 'react';
import { cn } from '@/lib/utils';
import { Label } from '@/components/ui/label';
import { Input } from '@/components/ui/input';

const FormField = React.forwardRef(({ className, id, label, children, hasError, errorText = 'Campo inválido', ...props }, ref) => {
  const compId = React.useId();

  // Verifica se o inputElement é React.Element e se tem a prop 'disabled'
  const isDisabled = React.Children.count(children) > 0 ? React.isValidElement(children) && children.props.disabled : props.disabled; // Se não tem children, assume que 'disabled' viria via props para o Input padrão

  // Se 'children' não for fornecido, tentamos renderizar um Input padrão.
  // Isso é flexível: você pode passar um Input, um Textarea ou outro componente.
  const inputElement = children ? (
    React.Children.only(children) // Garante que apenas um filho é passado
  ) : (
    <Input
      id={id ?? compId}
      aria-invalid={Boolean(hasError) || Boolean(props['aria-invalid'])}
      {...props}
    /> // Renderiza um Input padrão se não houver filhos
  );

  return (
    <div
      className={cn('c-form-field', 'space-y-1', isDisabled && '[&>label]:cursor-not-allowed [&>label]:opacity-50', className)}
      ref={ref}
    >
      {label && <Label htmlFor={id ?? compId}>{label}</Label>}

      {inputElement}

      {hasError && (
        <p
          className="mb-0 text-xs text-danger"
          role="alert"
          aria-live="polite"
        >
          {errorText}
        </p>
      )}
    </div>
  );
});
FormField.displayName = 'FormField';

export { FormField };
